import { customRef } from 'vue'

// from: https://lorisleiva.com/gists/abstract-local-storage-in-vue-3
// try using this too https://vuejs.org/api/reactivity-advanced.html#customref

export default function (key, defaultValue, delay=10) {
    let timeout
    return customRef((track, trigger) => ({
        get: () => {
            track()
            const value = localStorage.getItem(key)
            console.log("just read:",value)
            if (value===undefined || value === "undefined" ||value===null) {
                return defaultValue
            }
            console.log("just read bro:",value)
            return value ? JSON.parse(value) : defaultValue
        },
        set: value => {
            console.log("just wrote:",value)

            let dispatchname = key+'-localstorage-changed';
            console.log("dispatchname:", dispatchname)

            
              if (value === null) {
                localStorage.removeItem(key) //do this right away
                setTimeout( () => {
                  window.dispatchEvent(new CustomEvent(dispatchname, {
                      detail: {
                        storage: null
                      }
                    }));
                },100) // add a little delay to the other sections of the app so they can take a litte longer to load
              } else {
                  localStorage.setItem(key, JSON.stringify(value)) //do this right away
                  setTimeout( () => {
                    window.dispatchEvent(new CustomEvent(dispatchname, {
                        detail: {
                          storage: value
                        }
                      }));
                  },100) // add a little delay to the other sections of the app so they can take a litte longer to load
              }


            
           
            

            
            
            trigger()
        },
    }))
}